/*! Product description "Read More" truncation, ported from the OS2.0 theme's jQuery version in
    custom.js -- rewritten in vanilla JS since Venue doesn't ship jQuery. Collapses long product
    descriptions to ~3 lines with a fade and a button to reveal the rest; leaves short ones alone. */
function initDescriptionReadMore(root) {
  const scope = root || document;
  const targets = scope.querySelectorAll ? scope.querySelectorAll(".product-desc-readmore") : [];

  targets.forEach((content) => {
    if (content.dataset.readmoreInitialized) return;
    content.dataset.readmoreInitialized = "true";

    const computedStyle = window.getComputedStyle(content);
    let lineHeight = parseFloat(computedStyle.lineHeight);
    if (Number.isNaN(lineHeight)) {
      lineHeight = parseFloat(computedStyle.fontSize) * 1.6;
    }
    const collapsedHeight = Math.round(lineHeight * 3);
    const fullHeight = Math.ceil(content.scrollHeight);

    if (fullHeight <= collapsedHeight + 2) return;

    content.classList.add("is-collapsed");
    content.style.maxHeight = collapsedHeight + "px";

    const button = document.createElement("button");
    button.type = "button";
    button.className = "product-desc-readmore-btn";
    button.textContent = "Read More";
    button.setAttribute("aria-expanded", "false");
    button.addEventListener("click", (event) => {
      event.preventDefault();
      content.classList.remove("is-collapsed");
      content.style.maxHeight = "none";
      button.remove();
    });

    content.insertAdjacentElement("afterend", button);
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => initDescriptionReadMore());
} else {
  initDescriptionReadMore();
}
document.addEventListener("shopify:section:load", (event) => initDescriptionReadMore(event.target));
